<template>
  <div
      class="icon-item"
      :class="{selected:item.selected}"
      @mousedown="closeTaskbar"
      :style="{
        height: this.cell.height * 1 + 'px',
        width: this.cell.width * 1 + 'px',
        top: this.position.y + 'px',
        left: this.position.x + 'px'
      }"
  >
    <div class="icon-body" @click="onClick($event)" @dblclick="dblclick()" draggable="true">
      <div style="display: flex;flex-wrap: nowrap;position: relative">
        <my-icon :name="item.icon" :size="75" :enable="item.enable"></my-icon>
        <!--<div class="win-icon" :style="{ background: 'url(./icon/' + item.icon + '.png) no-repeat' } " style="background-size: contain" ></div>-->
        <el-badge type="danger" :value="badgeNum" class="badgeStyle" v-show="badgeNum!==0"></el-badge>
      </div>
      <div class="text">{{ item.name }}</div>
    </div>

  </div>
</template>

<script>


export default {
  name: 'AppIconXjh',
  components: {},
  props: {
    item: Object,
    grid: Object,
    cell: Object,
    order: Number,
    //select: Function,
    //dragstart: Function
    user: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      resizeTime: new Date().getTime()
    }
  },
  computed: {
    fixed() {
      return this.$store.state.wallpaper.fixed
    },
    position() {
      if (this.fixed && this.resizeTime > -1) {
        let location = this.item.jsonObj?.location || {}
        return this.$store.getters['wallpaper/getPosition'](location);
      } else {
        let x = Math.floor(this.order / this.grid.row) * this.cell.width;
        let y = Math.floor(this.order % this.grid.row) * this.cell.height;
        return {x, y}
      }
    },
    badgeNum() {
      let key = this.item?.badge_data_key;
      if (!key) {
        return 0;
      }

      return this.$store.getters['core/getBadgeData'](key) || 0
    }
  },
  created() {
    if (this.user.company !== 'XJH' && this.item.id === 'customer_entrance') {
      // this.onClick()
      this.dblclick()
    }
  },
  mounted() {
    let that = this
    window.addEventListener("resize", function () {
      that.resizeTime = new Date().getTime()
    })
  },
  methods: {
    closeTaskbar() {
      this.$store.commit('core/CLEAN_CONTEXT_MENU')
    },
    onClick() {
      if (this.$store.state.core.mobile) {
        this.openWindow()
      } else {
        this.$store.dispatch('core/selectIcon', this.item.id)
      }
    },
    dblclick() {
      if (this.$store.state.core.mobile) {
        return;
      }
      this.openWindow()
    },
    openWindow() {
      if (this.item.disabled) {
        return this.$message.error(this.$t('AppIcon.no_use', {name: this.item?.name}))
      } else if (this.item?.no_access) {
        return this.$message.error(this.$t('AppIcon.no_access', {name: this.item?.name}))
      }
      if (this.item.link_url) {
        window.open(this.item.link_url, "_blank");
        return;
      }

      let windowObj = {}
      windowObj.icon = this.item.icon;
      windowObj.component = this.item.component
      windowObj.componentParam = this.item.params
      windowObj.name = this.item.name;
      windowObj.badge_data_key = this.item.badge_data_key;
      windowObj.parentData = {
        form_component: this.item?.jsonObj?.form_component,
        show_tips: this.item?.jsonObj?.show_tips ?? false,
      }

      let win = this.item?.jsonObj?.window || {};
      windowObj.width = win.width || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.height = win.height || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.max = win.max || this.$store.getters['core/getGlobalWindowMax']
      // windowObj.max = true
      windowObj.max_icon = win.max_icon
      windowObj.min_icon = win.min_icon

      this.$store.dispatch('core/openWindow', windowObj)

    }
  }
}
</script>

<style lang="less" scoped>

@media screen and (max-width: 1050px) {
  .icon-item {
    margin: 0px 10px;
    /*border:1px dashed #fff;*/

    .icon-body {
      /*border:2px solid transparent;*/
      border-radius: 4px;
      top: 50%;
      left: 50%;

      .badgeStyle {
        position: absolute;
        z-index: 1;
        right: 10px;
      }

      .text {
        min-height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: medium;
        margin-top: 10px;
        opacity: 0.7;
        color: #0084ff;
        /*margin:0 -10px; */
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-all;
        text-overflow: ellipsis;
        padding-bottom: 5px;
        text-shadow: none
      }
    }
  }

  .context-menu-section {
    position: absolute;
  }
}

.icon-item {
  margin: 0px 10px;
  /*border:1px dashed #fff;*/

  .icon-body {
    /*border:2px solid transparent;*/
    border-radius: 4px;
    top: 50%;
    left: 50%;

    .badgeStyle {
      position: absolute;
      z-index: 1;
      right: 10px;
    }

    .text {
      min-height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: medium;
      margin-top: 10px;
      opacity: 0.7;
      color: #0084ff;
      /*margin:0 -10px; */
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-all;
      text-overflow: ellipsis;
      padding-bottom: 5px;
      text-shadow: none
    }
  }
}

.context-menu-section {
  position: absolute;
}
</style>
